// extracted by mini-css-extract-plugin
export default {"header":"add_header__pvz+o","chooseType":"add_chooseType__5NQ3T","typeButton":"add_typeButton__nMHaP","active":"add_active__n0UBA"};